import { IReportPayroll } from '../../types/reportPayroll';
import GeneralEnumService from '../../enumerables/general-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import { changeToZeroMoment } from '../timeHelpers';

export const groupDataToCsv = (data: IReportPayroll[]): string[][] => {
    const groupData: string[][] = [['Id', 'Period start', 'Period End', 'Total Payable', 'Status']];
    const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('PayrollStatus') : {};
    const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);

    data.forEach((it) => {
        const dateFrom = it.periodStart?.date ? changeToZeroMoment(it.periodStart?.date, 'MMM D, YYYY') : '';
        const dateTo = it.periodEnd?.date ? changeToZeroMoment(it.periodEnd?.date, 'MMM D, YYYY') : '';
        const sumTotal: string = it?.sumTotal ? `$${it.sumTotal}` : '0';
        const id: string = it?.id ? `${it.id}` : '0';
        let valuestatus: string | SelectObject | undefined = statusItems.find((its) => +its.value === +it.status);
        valuestatus = valuestatus ? `${valuestatus?.label}` : '';
        groupData.push([id, dateFrom, dateTo, sumTotal, valuestatus]);
    });

    return groupData;
};
